'use client';
import React, { useState } from 'react';
import { Calendar, Download, Printer, RefreshCw, ChevronDown } from 'lucide-react';

const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

export default function DashboardHeader() {
  const [selectedMonth, setSelectedMonth] = useState('May 2026');
  const [showMonthPicker, setShowMonthPicker] = useState(false);

  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
      <div>
        <h1 className="text-2xl font-600 text-foreground" style={{ fontWeight: 600 }}>
          Teacher Accountability Dashboard
        </h1>
        <p className="text-sm text-muted-foreground mt-0.5">
          Northfield Secondary School &mdash; Last updated: 14 May 2026, 07:06
        </p>
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        {/* Month Picker */}
        <div className="relative">
          <button
            type="button"
            onClick={() => setShowMonthPicker(!showMonthPicker)}
            className="flex items-center gap-2 px-3 py-2 rounded-lg border border-border bg-card text-sm font-500 text-foreground hover:bg-muted transition-colors"
            style={{ fontWeight: 500 }}
          >
            <Calendar size={14} className="text-muted-foreground" />
            {selectedMonth}
            <ChevronDown size={14} className="text-muted-foreground" />
          </button>
          {showMonthPicker && (
            <div className="absolute right-0 top-full mt-1 z-20 bg-card border border-border rounded-xl shadow-lg p-2 grid grid-cols-3 gap-1 w-56 fade-in">
              {MONTHS?.map((m) => (
                <button
                  key={`month-${m}`}
                  type="button"
                  onClick={() => { setSelectedMonth(`${m} 2026`); setShowMonthPicker(false); }}
                  className={`text-xs px-2 py-1.5 rounded-lg font-500 transition-colors ${
                    selectedMonth?.startsWith(m)
                      ? 'bg-primary text-primary-foreground'
                      : 'text-foreground hover:bg-muted'
                  }`}
                  style={{ fontWeight: 500 }}
                >
                  {m?.slice(0, 3)}
                </button>
              ))}
            </div>
          )}
        </div>

        {/* Export */}
        <button
          type="button"
          className="flex items-center gap-2 px-3 py-2 rounded-lg border border-border bg-card text-sm font-500 text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
          style={{ fontWeight: 500 }}
          title="Export attendance data as CSV"
        >
          <Download size={14} />
          <span className="hidden sm:inline">Export</span>
        </button>

        <button
          type="button"
          className="flex items-center gap-2 px-3 py-2 rounded-lg border border-border bg-card text-sm font-500 text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
          style={{ fontWeight: 500 }}
          title="Print this dashboard view"
          onClick={() => window.print()}
        >
          <Printer size={14} />
          <span className="hidden sm:inline">Print</span>
        </button>

        <button
          type="button"
          className="flex items-center gap-2 px-3 py-2 rounded-lg bg-primary text-primary-foreground text-sm font-500 hover:bg-primary/90 transition-all duration-150 active:scale-95"
          style={{ fontWeight: 500 }}
          title="Refresh dashboard data"
        >
          <RefreshCw size={14} />
          <span className="hidden sm:inline">Refresh</span>
        </button>
      </div>
    </div>
  );
}